export default __webpack_public_path__ + "media/vue/img/whence/whence-logo-plain-635925d8a558cbe85b67b25131682a39.png";